import React from 'react';

import { MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';

import { Container } from './styles';

import { CheckboxProps } from './interface';

const Checkbox: React.FC<CheckboxProps> = ({ onClick, label, status }) => {
  return (
    <Container status={status} onClick={onClick}>
      {status ? (
        <MdRadioButtonChecked size={32} color={'#333'} />
      ) : (
        <MdRadioButtonUnchecked size={32} color={'#333'} />
      )}

      <span>{label}</span>
    </Container>
  );
};

export default Checkbox;
